import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class PraktikaAppointmentProceduresTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['appointment_procedures.csv'];
  commands = [
    `sed -i -e 's/iAppointmentId/iAppointmentId2/2'`,
    `sed -i -e 's/dtCompleted/dtCompleted2/2'`,
  ];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
